<template>
  <nav class="mt-2">
    <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
      <!-- Menú Principal -->
      <li class="nav-item">
        <router-link :to="{ name: 'app-home' }" class="nav-link">
          <i class="nav-icon fas fa-th"></i>
          <p>Panel principal</p>
        </router-link>
      </li>

      <!-- Mis vacaciones -->
      <li class="nav-item" v-if="authUser.organization_charts_id != 1">
        <router-link :to="{ name: 'my_holidays' }" class="nav-link" active-class="active">
          <i class="nav-icon fas fa-plane-departure"></i>
          <p>Mis vacaciones</p>
        </router-link>
      </li>

      <!-- Mi equipo con submenú -->
      <li class="nav-item has-treeview" :class="{ 'menu-open': subMenus['myTeam'] }" v-if="catalogue.related_users_num > 0">
        <a href="#" class="nav-link" @click="toggleSubMenu('myTeam', $event)">
          <i class="nav-icon fas fa-users"></i>
          <p>
            Mi equipo
            <i class="right fas fa-angle-left"></i>
          </p>
        </a>
        <ul class="nav nav-treeview" v-show="subMenus['myTeam']">
          <li class="nav-item">
            <router-link :to="{ name: 'my_team' }" class="nav-link" active-class="active">
              <i class="nav-icon fas fa-users"></i>
              <p>Mi equipo</p>
            </router-link>
          </li>
          <li class="nav-item" v-if="catalogue.related_users_num > 0 || authUser.profile.areas_id == 2">
            <router-link :to="{ name: 'validate_holiday' }" active-class="active" class="nav-link">
              <i class="nav-icon fas fa-calendar-check"></i>
              <p>Aprobar vacaciones</p>
            </router-link>
          </li>
        </ul>
      </li>

      <!-- Usuarios -->
      <li class="nav-item" v-can="'users'">
        <router-link to="/users" active-class="active" class="nav-link">
          <i class="nav-icon fas fa-user"></i>
          <p>Usuarios</p>
        </router-link>
      </li>

      <!-- Clientes -->
      <li class="nav-item" v-can="'customers'">
        <router-link to="/customers" active-class="active" class="nav-link">
          <i class="nav-icon fas fa-building"></i>
          <p>Clientes</p>
        </router-link>
      </li>

      <!-- Proyectos -->
      <li class="nav-item" v-can="'projects'">
        <router-link to="/projects" active-class="active" class="nav-link">
          <i class="nav-icon fas fa-project-diagram"></i>
          <p>Proyectos</p>
        </router-link>
      </li>

      <!-- Organigrama -->
      <li class="nav-item" v-can="'organization'">
        <router-link to="/organization" active-class="active" class="nav-link">
          <i class="nav-icon fas fa-network-wired"></i>
          <p>Organigrama</p>
        </router-link>
      </li>

      <!-- Calendario -->
      <li class="nav-item" v-can="'calendar'">
        <router-link to="/calendar" active-class="active" class="nav-link">
          <i class="nav-icon fas fa-calendar"></i>
          <p>Calendario</p>
        </router-link>
      </li>

      <!-- Permisos -->
      <li class="nav-item" v-can="'permissions'">
        <router-link to="/permissions" active-class="active" class="nav-link">
          <i class="nav-icon fas fa-lock"></i>
          <p>Permisos</p>
        </router-link>
      </li>

      <!-- Configurar Vacaciones -->
      <li class="nav-item" v-can="'holidays_config'">
        <router-link to="/holidays_config" active-class="active" class="nav-link">
          <i class="nav-icon fas fa-sliders-h"></i>
          <p>Configurar Vacaciones</p>
        </router-link>
      </li>

      <!-- Vacaciones Extras -->
      <li class="nav-item" v-can="'holidays_extras'">
        <router-link to="/holidays_extras" active-class="active" class="nav-link">
          <i class="nav-icon fa-regular fa-square-plus"></i>
          <p>Vacaciones Extras</p>
        </router-link>
      </li>

      <!-- Vacaciones -->
      <li class="nav-item" v-can="'holidays'">
        <router-link to="/holidays" active-class="active" class="nav-link">
          <i class="nav-icon fas fa-plane"></i>
          <p>Vacaciones</p>
        </router-link>
      </li>

      <!-- Evaluaciones con submenú -->
      <li class="nav-item has-treeview" :class="{ 'menu-open': subMenus['evaluations'] }">
        <a href="#" class="nav-link" @click="toggleSubMenu('evaluations', $event)">
          <i class="nav-icon far fa-chart-bar"></i>
          <p>
            Evaluaciones
            <i class="right fas fa-angle-left"></i>
          </p>
        </a>
        <ul class="nav nav-treeview" v-show="subMenus['evaluations']">
          <li class="nav-item">
            <router-link to="/evaluations" active-class="" class="nav-link">
              <i class="nav-icon fas fa-receipt"></i>
              <p>Lista Evaluaciones</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/evaluations/autoevaluation" active-class="" class="nav-link">
              <i class="nav-icon fas fa-traffic-light"></i>
              <p>Auto Evaluación</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/evaluations/manager-evaluations" active-class="" class="nav-link">
              <i class="nav-icon fas fa-list-ol"></i>
              <p>Evaluaciones asignadas</p>
            </router-link>
          </li>
          <!-- <li class="nav-item">
            <router-link to="/evaluations/manager-goals" active-class="" class="nav-link">
              <i class="nav-icon fas fa-tasks"></i>
              <p>Evaluaciones De alcances</p>
            </router-link>
          </li> -->
           <li class="nav-item">
            <router-link to="/evaluations/report-evaluations" active-class="" class="nav-link">
              <i class="nav-icon far fa-clipboard"></i>
              <p>Reporte de evaluaciones</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/evaluations/my-scores" active-class="" class="nav-link">
              <i class="nav-icon fas fa-star-half-alt"></i>
              <p>Mis Calificaciones</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/evaluations/global-report-evaluations" active-class="" class="nav-link">
              <i class="nav-icon fas fa-chart-line"></i>
              <p>Resumen de evaluaciones </p>
            </router-link>
          </li>

        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import Catalogue from '@/services/catalogue';

export default {
  data() {
    return {
      catalogue: new Catalogue(),
      subMenus: { // Estado de los submenús
        myTeam: false,
        evaluations: false,
      }
    };
  },
  mounted() {
    this.catalogue.get_related_users();
  },
  computed: {
    ...mapGetters({
      'authUser': 'auth/user',
    }),
  },
  methods: {
    toggleSubMenu(menu, event) {
      try {
        event.stopPropagation(); // Detener la propagación del evento
        this.$set(this.subMenus, menu, !this.subMenus[menu]);
      } catch (err) {
        console.error("Error al togglear el submenú:", err);
      }
    },
  },
};
</script>

<style scoped>
/* Agregar estilo para el submenú plegable */
.nav-treeview {
  display: none;
  background-color: #343a40; /* Fondo más oscuro */
}
.nav-treeview.open {
  display: block;
}
.has-treeview .nav-treeview {
  display: none;
}
.has-treeview.menu-open .nav-treeview {
  display: block;
}
/* Estilo para enlaces de submenús */
.nav-treeview .nav-link {
  color: rgba(255, 255, 255, 0.7); /* Color de texto más opaco */
}
.nav-treeview .nav-link.active {
  background-color: rgba(255, 255, 255, 0.1); /* Fondo más oscuro para el elemento activo */
}
</style>
